<div #signUpModal class="modal fade" tabindex="-1" aria-labelledby="signUpModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content text-center">
            <div class="modal-header border-0 pb-0">
                <div class="row">
                    <div class="col text-center">
                        <img style="height: 30px" src="../../../assets/img-gyan.png" alt="Gyan Logo" />
                        <span class="font-weight-bold section-title">Gyan</span>
                    </div>
                    <div class="col-auto">
                        <div type="button" class="gyan-popup-close" aria-label="Close" (click)="closeSignUpModal()">
                            <div class="modal-close-icon"></div>
                        </div>
                        <!-- <button type="button" style="width: 20px !important; color: #2a3747 !important; height: 20px !important;" class="btn-close" (click)="closeSignUpModal()"
                            aria-label="Close"></button> -->
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="text-center d-block" *ngIf="!isSignUp">
                    <!-- Center all content -->
                    <div style="display: none">
                        <div class="modal-title mb-2 Signup-header-font" id="logInModalLabel">Your Auto curating knowledge engine</div>
                    </div>
                    <p class="Signup-p-font" style="padding-bottom: 0px; margin-bottom: 0px">
                        To request free access to a Gyan Enterprise trial license, simply reach out to us with <br />
                        your name, title, and company name to this email address:
                    </p>
                    <a class="Signup-a-font" href="mailto:support@gyan-research.com">support&#64;gyan-research.com</a>
                    <p class="Signup-l-font">Our team will promptly follow up with you. Thank you!</p>
                    <div style="display: none">
                        <div class="Signup-header-font">Sign Up</div>
                        <div class="btn-wrapper text-center mt-3">
                            <!-- Center the buttons -->
                            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="signup-form" name="signup-form">
                                <div class="mb-3">
                                    <input
                                        (blur)="validateFirstName()"
                                        type="text"
                                        class="form-control"
                                        formControlName="firstName"
                                        [ngClass]="(registerForm.controls['firstName'].touched || submitted) && registerForm.controls['firstName'].errors ? 'input-box-error' : ''"
                                        placeholder="First Name"
                                    />
                                    <div
                                        *ngIf="(registerForm.controls['firstName'].touched || submitted) && registerForm.controls['firstName'].errors"
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">First name required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input
                                        (blur)="validateLastName()"
                                        type="text"
                                        class="form-control"
                                        formControlName="lastName"
                                        [ngClass]="(registerForm.controls['lastName'].touched || submitted) && registerForm.controls['lastName'].errors ? 'input-box-error' : ''"
                                        placeholder="Last Name"
                                    />
                                    <div
                                        *ngIf="(registerForm.controls['lastName'].touched || submitted) && registerForm.controls['lastName'].errors"
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Last name required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input
                                        type="email"
                                        name="emailaddress"
                                        class="form-control text-black"
                                        placeholder="Email"
                                        autocomplete="emailAddress"
                                        formControlName="emailAddress"
                                        (blur)="emailIdInputBox()"
                                        [ngClass]="
                                            ((registerForm.controls['emailAddress'].touched || submitted) && registerForm.controls['emailAddress'].errors) ||
                                            (registerForm.controls['emailAddress'].touched && registerForm.controls['emailAddress'].errors) ||
                                            isEmailRegistred
                                                ? 'input-box-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        class="d-flex justify-content-center"
                                        *ngIf="(registerForm.controls['emailAddress'].touched || submitted) && registerForm.controls['emailAddress'].hasError('required')"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Email addresss required</span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center" *ngIf="(registerForm.controls['emailAddress'].touched || submitted) && invalidEmail">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Enter a valid email address</span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center" *ngIf="(registerForm.controls['emailAddress'].touched || submitted) && isEmailRegistred">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">This email already exists.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Password"
                                        (blur)="checkPassword()"
                                        formControlName="currentPassword"
                                        [ngClass]="
                                            (registerForm.controls['currentPassword'].touched || submitted) && (registerForm.controls['currentPassword'].errors || pwdDoNotMatch)
                                                ? 'input-box-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        *ngIf="(registerForm.controls['currentPassword'].touched || submitted) && registerForm.controls['currentPassword'].hasError('required')"
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Password required</span>
                                        </div>
                                    </div>
                                    <div *ngIf="(registerForm.controls['currentPassword'].touched || submitted) && pwdDoNotMatch" class="d-flex justify-content-center">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Passwords do not match</span>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="
                                            (registerForm.controls['currentPassword'].touched || submitted) && registerForm.controls['currentPassword'].hasError('invalidPassword')
                                        "
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1"
                                                >The password must be between 8 and 64 characters.<br />
                                                Your password must have at least 3 of the following:<br />
                                                - a lowercase letter<br />
                                                - an uppercase letter<br />
                                                - a number<br />
                                                - a symbol<br
                                            /></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Confirm Password"
                                        formControlName="confirmPassword"
                                        (blur)="checkPassword()"
                                        [ngClass]="
                                            (registerForm.controls['confirmPassword'].touched || submitted) && registerForm.controls['confirmPassword'].errors
                                                ? 'input-box-error'
                                                : ''
                                        "
                                    />
                                    <div
                                        *ngIf="(registerForm.controls['confirmPassword'].touched || submitted) && registerForm.controls['confirmPassword'].hasError('required')"
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">Confirm Password required</span>
                                        </div>
                                    </div>
                                    <div
                                        *ngIf="
                                            (registerForm.controls['confirmPassword'].touched || submitted) && registerForm.controls['confirmPassword'].hasError('invalidPassword')
                                        "
                                        class="d-flex justify-content-center"
                                    >
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span class="sub-head-s3 error-msg m-1">
                                                The password must be between 8 and 64 characters.<br />
                                                Your password must have at least 3 of the following:<br />
                                                - a lowercase letter<br />
                                                - an uppercase letter<br />
                                                - a number<br />
                                                - a symbol<br />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-block text-center mt-2">
                                    <!-- Add margin-top -->
                                    <button class="btn-custom btn-primary">Sign Up</button>
                                </div>
                            </form>
                            <hr class="mt-4" />
                            <div class="d-block text-center mt-4">
                                <!-- Add margin-top -->
                                <button class="gyan-signin-btn p-1 gray-color custom-signin-btn-disable">
                                    <img class="img-fluid" src="./../../assets/google.svg" alt="Google Icon" />
                                    <span class="pl-2">Sign in with Google</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center d-block" *ngIf="isSignUp">
                    <!-- Center all content -->
                    <div class="modal-title mb-2 Signup-header-font" id="logInModalLabel">Thank you for signing up!</div>
                    <p class="Signup-p-font">Please check your email to verify your account and get started.</p>
                </div>
            </div>
        </div>
    </div>
</div>
